
import lamba_hero2 from "../assets/images/lamba_hero2.png"
import lamba_scope1 from "../assets/images/lamba_scope1.png"
import lamba_scope2 from "../assets/images/lamba_scope2.png"
import lamba_highlight1 from "../assets/images/lamba_highlight1.png"
import lamba_highlight2 from "../assets/images/lamba_highlight2.png"
import lamba_highlight3 from "../assets/images/lamba_highlight3.png"
import lamba_highlight4 from "../assets/images/lamba_highlight4.png"
import lamba_mobileHero from "../assets/images/lamberMobile-hero.png"
import lambaMobile_project1 from "../assets/images/lambaMobile-project1.png"
import lambaMobile_project2 from "../assets/images/lambaMobile-project2.png"
import lambaMobile_hightlight1 from "../assets/images/lambaMobile-hightlight1.png"
import lambaMobile_hightlight2 from "../assets/images/lambaMobile-hightlight2.png"
import lambaMobile_hightlight3 from "../assets/images/lambaMobile-hightlight3.png"
import lambaMobile_hightlight4 from "../assets/images/lambaMobile-hightlight4.png"
import pebble_HeroBg from "../assets/images/pebble-heroBg.svg";
import projectImg1 from "../assets/images/pebble_project_image1.svg";
import projectImg2 from "../assets/images/pebble_project_image2.svg";
import highlightImg1 from "../assets/images/highlightImg1.svg";
import highlightImg2 from "../assets/images/highlightImg2.svg";
import highlightImg3 from "../assets/images/highlightImg3.svg";
import highlightImg4 from "../assets/images/highlightImg4.svg";

export const datas = [
  {
    id: 1,
    title: "Lambatoken Mobile App",
    slug: "lambatoken-app",
    sub: "mobile application",
    description:
      "Lambatoken Mobile is an app that does sales and NFTs and other franchise",
    link: "https://play.google.com/store/apps/details?id=com.daveblaq.lambabros",
    heroBg: lamba_mobileHero,
    project_Scope:
      "We have built an App with an inclusive solution where businesses can access creative promotions. This comes with the development of a decentralized content creation marketplace where brands meet gamified content creators that will create attention for their products/services, and these creators are rewarded in Lambatoken. We also included a decentralized discount store for brands to attract more customers with their discount offers in a smarter way. These products services are converted to vouchers and bought with funds from our wallet. These vouchers can be transferable and easily redeemable. For example, we can have medical check-up cost in vouchers, and events too can sell tickets using this unique way. The use-case is endless.",
    projectImg_web: [lambaMobile_project1, lambaMobile_project2],
    highlight: [
      lambaMobile_hightlight1,
      lambaMobile_hightlight2,
      lambaMobile_hightlight3,
      lambaMobile_hightlight4,
    ],
    tech_stack: ["React Native", "Redux tool kit", "Laravel framework", "Expo"],
  },
  {
    id: 2,
    title: "Lambatoken brand page",
    slug: "lambatoken",
    sub: "website",
    description:
      "This is a landing page for on-boarding brands, sensitizing them on the use of the Lambatoken for brand exposure to organic community  presence and how they can benefit from the daily tasks carried out in the community in exchange for rewards and freebies",
    link: "https://hol.lambatoken.com/",
    heroBg: lamba_hero2,
    project_Scope:
      "We have built an App with an inclusive solution where businesses can access creative promotions. This comes with the development of a decentralized content creation marketplace where brands meet gamified content creators that will create attention for their products/services, and these creators are rewarded in Lambatoken. We also included a decentralized discount store for brands to attract more customers with their discount offers in a smarter way. These products services are converted to vouchers and bought with funds from our wallet. These vouchers can be transferable and easily redeemable. For example, we can have medical check-up cost in vouchers, and events too can sell tickets using this unique way. The use-case is endless.",
    projectImg_web: [lamba_scope1, lamba_scope2],
    highlight: [
      lamba_highlight1,
      lamba_highlight2,
      lamba_highlight3,
      lamba_highlight4,
    ],
    tech_stack: ["React.js", "Bootstrap", "AOS animation"],
  },
  {
    id: 3,
    title: "Pebble",
    slug: "pebble",
    sub: "website",
    description: "Website development, UI designs ",
    link: "https://pebble-beryl.vercel.app/",
    heroBg: pebble_HeroBg,
    project_Scope:
      "Cowry wise wants to make saving and investing simple and highly rewarding for everyone, particularly young Africans. The goal of the brand revamp was to express this simple want with utmost clarity, target the brand pain points, and strengthen the brand position.",
    projectImg_web: [projectImg1, projectImg2],
    highlight: [highlightImg1, highlightImg2, highlightImg3, highlightImg4],
    tech_stack: [
      "Micro interactions",
      "React framework",
      "Tailwind css",
      "Figma",
    ],
  },
];
